var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("textarea", {
    attrs: {
      id: _vm.id,
      placeholder: _vm.placeholder,
      rows: _vm.rows,
      maxlength: _vm.limit,
      disabled: _vm.isDisabled
    },
    domProps: { value: _vm.value },
    on: {
      input: function($event) {
        return _vm.onInput($event.target.value)
      },
      focus: function($event) {
        return _vm.$emit("focus")
      },
      blur: function($event) {
        return _vm.$emit("blur")
      },
      keyup: function($event) {
        return _vm.$emit("keyup")
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31356cba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31356cba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AutosizeTextarea.vue
// module id = ALs0
// module chunks = 1